import gql from 'graphql-tag'

export const FIND_CLIENT_BY_NAME = gql`
    query findClientByName($name: String!){
        findClientByName(name: $name) {
            id
            codigo
            razonSocial
            nombreFantasia
            domicilio
            telefono
        }
    }
`;

export const UPDATE_PHONE = gql`
    mutation updateClientPhone($cli_id: Float!, $phone: String!, $type: String!, $id_default: Boolean!, $current_user: String!){
        updateClientPhone(
            cli_id: $cli_id,
            phone: $phone, 
            type: $type,
            id_default: $id_default,
            current_user: $current_user
        )
    }
`;